import React from 'react';
import './AttendanceCards.css';

const AttendanceCardWeek = ({ title, present, absent, late }) => {
  return (
    <div className="attendance-card">
      <h3>{title}</h3>
      
      <div className="progress-container">
        <div className="progress-group">
          <div className="progress-bar present" style={{ width: `${present}%` }}></div>
          <span className="progress-value present">{present}</span>
          <span className="progress-label">Presend Days</span>
        </div>
        
        <div className="progress-group">
          <div className="progress-bar absent" style={{ width: `${absent}%` }}></div>
          <span className="progress-value absent" >{absent}</span>
          <span className="progress-label">Absent Days</span>
        </div>
        
        {/* <div className="progress-group">
          <div className="progress-bar late" style={{ width: `${late}%` }}></div>
          <span className="progress-value late">{late}%</span>
          <span className="progress-label">Late</span>
        </div> */}
      </div>
    </div>
  );
};

export default AttendanceCardWeek;